export default "__VITE_ASSET__cae08788__"